import { Ipagination } from '@/utils';
import actionType from '../actions/staff/actionType';

export interface Iemployee {
  createBy: string; // 创建人
  createTime: string; // auth服务生成
  employeeNo: string; // 员工编号
  gender: number; // 0男1女
  id: number;
  jobStatus: number; // 0离职，1在职
  mobile: string; // 手机号
  name: string; // 姓名
  password: string;
  status: number; // 0禁用，1启用
  sysId: string; // 归属系统
  type: number; // 0总部 1酒店
  updateBy: string; // 修改人
  updateTime: string; // auth服务修改
}

interface StaffState extends Ipagination {
  cleanerList?: Array<Iemployee>;
  staffListLoading?: boolean;
  switchEnableStaffLoading?: boolean;
  switchDisableStaffLoading?: boolean;
}

const initialState: StaffState = {
  cleanerList: [],
  staffListLoading: false,
  switchEnableStaffLoading: false,
  switchDisableStaffLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_STAFF_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.STAFF_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.STAFF_CREATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.STAFF_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.STAFF_DELETE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.STAFF_DETAIL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
